























































import VueOptions from '@utils/VueOptions'
import CalendarService from '@services/CalendarService'
import AudienceListingDetail from '@ui/AudienceListing/AudienceListingDetail'
import OmnichannelListingDetail from '@ui/AudienceListing/OmnichannelListingDetail'
import CampaignAudienceListingPricingBox from './CampaignAudienceListingPricingBox'

settings =
  name: 'AudienceListingShow'

  resources:
    audience_listing:
      resourceName: 'audience_listing'
      slug: 'audience_listings/:audienceListingId'

    campaign:
      resourceName: 'campaign'
      slug: 'campaigns/:campaignId'
      lazy: true

    listing_line_items:
      resourceName: 'shopping_cart_line_item'
      slug: 'campaigns/:campaignId/scanner/audience_listings/:audienceListingId/shopping_cart_line_items'
      params:
        segment: ':segment'

    activation_plan:
      resourceName: 'activation_plan'
      slug: 'campaigns/:campaignId/activation_plans/:activationPlanId'
      fetch: false

    nearbyPOIs:
      resourceName: 'nearby_poi'
      slug: 'nearby_pois/:audienceListingId'
      fetch: false

  vue:
    components: {
      AudienceListingDetail,
      OmnichannelListingDetail,
      CampaignAudienceListingPricingBox,
    }

    data: ->
      segment: null
      audienceListingDetailModal:
        show: true

    computed:
      activationPlanId: -> "#{@$route.params.campaignId}:#{@audienceListingId}:#{encodeURIComponent(@segment)}"

      audienceListing: ->
        return null unless @audience_listing
        listing = @audience_listing
        listing.calendar_dates = CalendarService.normalizeEvents listing.calendar_dates
        listing
      audienceListingId: -> @$route.params.listingId

      lineItem: -> @listing_line_items?[0]

      target: -> @getPageSession "matches:#{@campaign?.id}"

      targetGeo: ->
        t = @target || @campaign?.target || {}
        t.geo || {}

      actionsForAudienceListingDetail: ->
        favoriteAudienceListingTrigger: @favoriteAudienceListingTrigger
        unfavoriteAudienceListingTrigger: @unfavoriteAudienceListingTrigger
        addSuperNote: @addSuperNote

      actionsForOmnichannelListingDetail: ->
        editActivationPlan: @editActivationPlan
        removeFromCartTrigger: @removeAudienceListingFromCartTrigger
        addSuperNote: @addSuperNote

      actionsForPricingBox: ->
        addToCartTrigger: @addToCartTrigger
        editActivationPlan: @editActivationPlan
        removeFromCartTrigger: @removeAudienceListingFromCartTrigger

      venues: -> [
        { label: 'The Stadium, Dana Point, CA', value: '111' }
        { label: 'The Museum, New York, NY', value: '222' }
        { label: 'Central Park, New York, NY', value: '333' }
      ]

    mounted: ->
      @initializeSegment()
      @fetchNearbyPOIs()

    methods:
      initializeSegment: ->
        # return if segment did not change
        return if @segment and @segment is @$route.query.segment

        # wait for campaign and audience listing to load
        return unless @campaign and @audienceListing

        # keep only relevant spaces to the campaign
        allSpaces = Object.values @audienceListing.spaces
        spaces = allSpaces.filter((space) => !!@campaignCreativeForSpace(space, @campaign.creatives))
        omnichannelSpaces = allSpaces.filter((space) => space.type is 'omnichannel')

        # try to use segment from route or select the first available one
        segment = @$route.query.segment if spaces.find((space) => space.segment is @$route.query.segment)
        segment = @$route.query.segment if @audienceListing.is_omnichannel and omnichannelSpaces.find((space) => space.segment is @$route.query.segment)
        segment ||= spaces[0].segment
        @segment = segment

        # rewrite query in the path
        query = { ...@$route.query, segment }
        @$router.replace { query }

        # reload activation plan
        @fetchActivationPlan()

      closeModal: ->
        @$router.push(@$route.path.split('/listings/')[0])

      fetchNearbyPOIs: ->
        poi_ids = @targetGeo.poi_list?.map((poi) -> poi.id)
        @fetch 'nearbyPOIs', { audience_listing_id: @audienceListingId, campaign_id: @campaignId, poi_ids }

      addToCartTrigger: (audience_listing_id, segment) ->
        payload = { audience_listing_id, segment, target: @target }
        @triggerResource 'listing_line_items', 'add_to_cart', payload
      onListingLineItemsAddToCart: (data, response) ->
        @fetchActivationPlan()
        @fetch 'listing_line_items'

      removeAudienceListingFromCartTrigger: (audienceListing, segment) ->
        payload = { audience_listing_id: audienceListing.id, segment }
        @triggerResource 'listing_line_items', 'remove_listing_from_cart', payload
      onListingLineItemsRemoveListingFromCart: ->
        @fetchActivationPlan() unless @audienceListing.is_omnichannel

      addSuperNote: (newSuperNote) ->
        @triggerResource 'audience_listing', 'add_super_note', { note: newSuperNote }

      editActivationPlan: (audienceListing, segment) ->
        routeName = 'CampaignListingFeedListingEdit'
        routeName = 'CampaignCheckoutListingEdit' if @$route.name is 'CampaignCheckoutListingShow'
        params =
          listingId: audienceListing.id
          campaignId: @campaign.id
        query = { segment }
        @$router.push { name: routeName, params, query }

      favoriteAudienceListingTrigger: (listing) ->
        @triggerResource 'campaign', 'favorite_audience_listing', { audience_listing_id: listing.id }
      unfavoriteAudienceListingTrigger: (listing) ->
        @triggerResource 'campaign', 'unfavorite_audience_listing', { audience_listing_id: listing.id }

      fetchActivationPlan: ->
        return unless @segment

        payload =
          id: @activationPlanId,
          shopping_cart_id: @lineItem?.shopping_cart_id,
          target: @target

        @fetch 'activation_plan', payload

      onLoadCollectionCompleted: (resourceKey) ->
        switch resourceKey
          when 'listing_line_items'
            @fetchActivationPlan()

    watch:
      audienceListing: ->
        @initializeSegment()

      campaign: ->
        @initializeSegment()
        @fetchNearbyPOIs()

      '$route.query.segment': ->
        @initializeSegment()

export default VueOptions.vue settings
